//
// The subscription of an organization. Mirrored by numeric value from the API (SubscriptionTypes on the
// tenant). Stored on the tenant; Phase 1 gates no feature on it.
//
export enum SubscriptionTypes {
  Trial = 0,
  Foundation = 1,
  Scale = 2,
  Enterprise = 3,
  Internal = 100,
}
